import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'LOGIN_ACCOUNT_RECOVERY_ID_UPLOAD_TITLE',
    defaultMessage: 'Prüfung Ihrer Identität',
  },
  description: {
    id: 'LOGIN_ACCOUNT_RECOVERY_ID_UPLOAD_DESCRIPTION',
    defaultMessage:
      'Dieser Schritt dient dem Schutz Ihrer Daten: Laden Sie ein Bild mit der Vorderseite Ihres Personalausweises oder Ihres Führerscheins hoch.',
  },
  fileUploadAddLabel: {
    id: 'LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_ADD_LABEL',
    defaultMessage: 'Foto aufnehmen oder auswählen',
  },
  fileUploadMaxSize: {
    id: 'LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_MAX_SIZE',
    defaultMessage: '(max. 5MB)',
  },
  fileUploadChangeLabel: {
    id: 'LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_CHANGE_LABEL',
    defaultMessage: 'Bild bearbeiten',
  },
  fileUploadExpiration: {
    id: 'LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_EXPIRATION',
    defaultMessage: 'Wie lange wird das Bild gespeichert?',
  },
  fileUploadExpirationTitle: {
    id: 'LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_EXPIRATION_TITLE',
    defaultMessage: 'Wie lange wird das Bild gespeichert?',
  },
  fileUploadExpirationParagraph: {
    id: 'LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_EXPIRATION_PARAGRAPH',
    defaultMessage:
      'Wir nutzen diese Bilder ausschließlich zur Prüfung Ihrer Identität. Nach maximal sechs Monaten löschen wir sie.',
  },
  fileUploadHowTo: {
    id: 'LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_HOW_TO',
    defaultMessage: 'Worauf Sie beim Bilder machen achten sollen.',
  },
  fileUploadHowToLikeSo: {
    id: 'LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_HOW_TO_LIKE_SO',
    defaultMessage: 'So geht es richtig:',
  },
  fileUploadHowToNoNo: {
    id: 'LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_HOW_TO_NO_NO',
    defaultMessage: 'So bitte nicht:',
  },
  fileUploadHowToReadable: {
    id: 'LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_HOW_TO_READABLE',
    defaultMessage: 'Leserlich',
  },
  fileUploadHowToSharp: {
    id: 'LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_HOW_TO_SHARP',
    defaultMessage: 'Scharf',
  },
  fileUploadHowToBlurry: {
    id: 'LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_HOW_TO_BLURRY',
    defaultMessage: 'Unscharf',
  },
  fileUploadHowToUpsideDown: {
    id: 'LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_HOW_TO_UPSIDE_DOWN',
    defaultMessage: 'Verkehrt herum',
  },
  fileUploadHowToBackside: {
    id: 'LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_HOW_TO_BACKSIDE',
    defaultMessage: 'Rückseite',
  },
  fileUploadHowToCutaway: {
    id: 'LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_HOW_TO_CUTAWAY',
    defaultMessage: 'Abgeschnitten',
  },
  fileUploadHowToCovered: {
    id: 'LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_HOW_TO_COVERED',
    defaultMessage: 'Verdeckt',
  },
  fileUploadMissing: {
    id: 'LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_MISSING_ERROR',
    defaultMessage: 'Bitte wählen Sie ein Bild aus um fortzufahren.',
  },
  fileUploadSizeExceeded: {
    id: 'LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_SIZE_EXCEEDED_ERROR',
    defaultMessage: 'Bitte wählen Sie ein Bild, das max. 5 MB groß ist.',
  },
  buttonContinue: {
    id: 'LOGIN_RECOVERY_CONTINUE',
    defaultMessage: 'Weiter',
  },
});
